import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import { loadHostDetailFailed, loadHostDetailSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';

export default function* loadHostDetail(action) {
  try {
    const {
      id,
      metricKeys,
    } = action.payload;
    const url = `${BACKEND_URL}/hosts/${id}/detail`;
    const pool = {};
    if (metricKeys) {
      pool.select_metric_keys = metricKeys;
    }
    const userDataResponse = yield makeRequest(url, pool, action, 'POST');
    const responseJson = yield userDataResponse.json();
    if (userDataResponse && userDataResponse.status === OK && responseJson.result) {
      yield put(loadHostDetailSuccessful(responseJson.result));
      yield call(resolveActionPromise(action, responseJson.result));
    } else {
      yield put(loadHostDetailFailed(responseJson));
      yield call(rejectActionPromise(action, responseJson));
    }
  } catch (e) {
    yield put(loadHostDetailFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
